<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Adicionar Pessoa' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>

  <ng-container *ngIf="loaded">
    <ion-item class="ion-margin">
      <ion-label position="stacked">
        {{'ensinos' | nomenclatura | async}}
      </ion-label>

      <ion-select
        toggleIcon="caret-down-sharp"
        interface="action-sheet"
        cancelText="{{ 'Cancelar' | translate}}"
        okText="{{ 'Confirmar' | translate}}"
        [(ngModel)]="ensinoReposicao"
        (ionChange)="changeEnsino()"
      >
        <ng-container *ngFor="let e of ensinos">
          <ion-select-option [value]="e.id"> {{e.nome}} </ion-select-option>
        </ng-container>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="inscritos.length" class="ion-margin">
      <ion-label position="stacked"> {{'Inscritos' | translate}} </ion-label>

      <ion-select
        toggleIcon="caret-down-sharp"
        interface="action-sheet"
        cancelText="{{ 'Cancelar' | translate}}"
        okText="{{ 'Confirmar' | translate}}"
        [(ngModel)]="idPessoa"
      >
        <ng-container *ngFor="let i of inscritos">
          <ion-select-option [value]="i.id"> {{i.nome}} </ion-select-option>
        </ng-container>
      </ion-select>
    </ion-item>

    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="8">
          <ion-button
            expand="block"
            class="btn-default"
            (click)="selecionarPessoa()"
          >
            {{'Buscar Pessoa' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div *ngIf="alert" class="center container-erro">
      <span>{{message}}</span>
    </div>
  </ng-container>
</ion-content>

<ion-footer>
  <ion-row class="ion-justify-content-center ion-margin-bottom">
    <ion-col size="8">
      <ion-button expand="block" class="btn-default" (click)="salvar()">
        {{'Adicionar' | translate}}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
